export default "__VITE_ASSET__BPG6jq52__"